import React, { useContext } from "react";
import { MenuItem } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../auth/AuthContext";
import {
  ArrowRightEndOnRectangleIcon,
  AdjustmentsVerticalIcon,
  MapPinIcon,
  ArchiveBoxIcon,
  TruckIcon,
  ShoppingCartIcon,
  ArchiveBoxArrowDownIcon,
  ClipboardDocumentListIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
const CustomUnloginMenu = ({ accessToken, role }) => {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  const navigateWithLang = useLanguageNavigate();
  const { isLoggedIn, logout } = useContext(AuthContext);

  const handleLogout = () => {
    logout();

    navigateWithLang("/");
  };

  return (
    <div className="w-full">
      {isLoggedIn || accessToken ? (
        <>
          {role !== "admin" ? (
            <>
              <MenuItem>
                <button
                  onClick={() => navigateWithLang("/my-account/dashboard")}
                  className="flex justify-end w-full gap-2 px-4 py-2 text-sm font-medium text-gray-700 duration-300 border-b border-gray-200 text-end md:font-bold md:text-sm hover:bg-gray-100"
                >
                  {t("ControlBoxSection")}
                  <AdjustmentsVerticalIcon class="h-6 w-6 text-black" />
                </button>
              </MenuItem>
              <MenuItem>
                <button
                  onClick={() => navigateWithLang("/my-account/box-address")}
                  className="flex justify-end w-full gap-2 px-4 py-2 text-sm font-medium text-gray-700 duration-300 border-b border-gray-200 text-end md:font-bold md:text-sm hover:bg-gray-100"
                >
                  {t("CartChooseButton")}
                  <MapPinIcon class="h-6 w-6 text-black" />
                </button>
              </MenuItem>

              <MenuItem>
                <button
                  onClick={() => navigateWithLang("/my-account/buy-for-me")}
                  className="flex justify-end w-full gap-2 px-4 py-2 text-sm font-medium text-gray-700 duration-300 border-b border-gray-200 text-end md:font-bold md:text-sm hover:bg-gray-100"
                >
                  {t("ItemsBuyMeSection")}
                  <ShoppingCartIcon class="h-6 w-6 text-black" />
                </button>
              </MenuItem>
              <MenuItem>
                <button
                  onClick={() => navigateWithLang("/my-account/my-orders")}
                  className="flex justify-end w-full gap-2 px-4 py-2 text-sm font-medium text-gray-700 duration-300 border-b border-gray-200 text-end md:font-bold md:text-sm hover:bg-gray-100"
                >
                  {t("Company")}
                  <ClipboardDocumentListIcon class="h-6 w-6 text-black" />
                </button>
              </MenuItem>
              <MenuItem>
                <button
                  onClick={() =>
                    navigateWithLang("/my-account/your-box-contents")
                  }
                  className="flex justify-end w-full gap-2 px-4 py-2 text-sm font-medium text-gray-700 duration-300 border-b border-gray-200 text-end md:font-bold md:text-sm hover:bg-gray-100"
                >
                  {t("ListOfBoxCardOrders")}
                  <ArchiveBoxIcon class="h-6 w-6 text-black" />
                </button>
              </MenuItem>
              <MenuItem>
                <button
                  onClick={() => navigateWithLang("/my-account/my-shipments")}
                  className="flex justify-end w-full gap-2 px-4 py-2 text-sm font-medium text-gray-700 duration-300 border-b border-gray-200 text-end md:font-bold md:text-sm hover:bg-gray-100"
                >
                  {t("CustomOrders")}
                  <ArchiveBoxArrowDownIcon class="h-6 w-6 text-black" />
                </button>
              </MenuItem>

              <MenuItem>
                <button
                  onClick={() => navigateWithLang("/my-account")}
                  className="flex justify-end w-full gap-2 px-4 py-2 text-sm font-medium text-gray-700 duration-300 border-b border-gray-200 text-end md:font-bold md:text-sm hover:bg-gray-100"
                >
                  {t("SettingMyAccount")}
                  <Cog6ToothIcon class="h-6 w-6 text-black" />
                </button>
              </MenuItem>
            </>
          ) : (
            <MenuItem>
              <button
                onClick={() => navigateWithLang("/Dashboard")}
                className="flex justify-end w-full gap-2 px-4 py-2 text-sm font-medium text-gray-700 duration-300 border-b border-gray-200 text-end md:font-bold md:text-sm hover:bg-gray-100"
              >
                {t("ControlBoxSection")}
                <AdjustmentsVerticalIcon class="h-6 w-6 text-black" />
              </button>
            </MenuItem>
          )}

          <MenuItem>
            <button
              onClick={handleLogout}
              className="flex items-center justify-end w-full gap-2 px-4 py-2 text-sm font-medium text-red-400 duration-300 rounded-lg text-end md:font-bold md:text-sm hover:bg-gray-100"
            >
              {t("logout")}
              <ArrowRightEndOnRectangleIcon class="h-5 w-5 text-red-400" />
            </button>
          </MenuItem>
        </>
      ) : (
        <>

        </>
      )}
    </div>
  );
};

export default CustomUnloginMenu;
